import React from 'react'
import {
  Grid
} from '@mui/material'
import Filters from './Filters'
import DataViz from './DataViz'

function DataDisplay(){
  return (

    <Grid container spacing={2} sx={{ mt: '2em' }}>
      <Grid item md={2}>
          <Filters />
      </Grid>
      <Grid item md={10}>
          <DataViz />
      </Grid>
    </Grid>
  )
}

export default DataDisplay
